<script lang="ts" setup>
  definePage({
    meta: {
      layout: 'blank',
      unauthenticated: true,
    },
  })

  import { useForm } from 'laravel-precognition-vue'
  import { AxiosError, type AxiosResponse } from 'axios'
  import type { AuthResponse } from '@/types/forms/Auth.ts'
  import { useAuthStore } from '@stores/auth.ts'

  const route = useRoute<'auth-social-provider-login'>()
  const provider = route.params.provider
  const router = useRouter()
  const authStore = useAuthStore()
  const { showSnackbar } = useSnackbar()
  const { t } = useI18n()

  if (!provider || route.query.error) {
    showSnackbar({
      text: (route.query.error_description as string) || 'Login was cancelled',
      color: 'error',
    })
    router.replace({ name: 'root' })
  } else {
    try {
      const result = await useForm('post', `/auth/social/${provider}`, route.query ?? {}).submit() as AxiosResponse<AuthResponse>
      useTrackStore().track('social_login_success', { source: provider })
      authStore.authenticate(result.data.user, result.data.token)
      router.push((route.query.redirect as string) || { name: 'root' })
    } catch (e) {
      const message = e instanceof AxiosError
        ? e.response?.data?.message ?? t('error_during_social_login')
        : t('error_during_social_login')

      showSnackbar({ text: message, color: 'error' })
      router.replace({ name: 'root' })
    }
  }
</script>

<template>
  <div />
</template>
